import { render, staticRenderFns } from "./stockpurchaseReturn.vue?vue&type=template&id=d4b5c34a&scoped=true"
import script from "./stockpurchaseReturn.vue?vue&type=script&lang=js"
export * from "./stockpurchaseReturn.vue?vue&type=script&lang=js"
import style0 from "./stockpurchaseReturn.vue?vue&type=style&index=0&id=d4b5c34a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b5c34a",
  null
  
)

export default component.exports